import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "excel-equation",
  "use": "excel-equation-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol viewBox=\"0 0 19 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"excel-equation\">\n<path d=\"M15.7161 3.6275L14.6414 2.55273H4.25195L10.7006 9.00134L4.25195 15.4499H14.6414L15.7161 14.3752\" stroke=\"#464646\" stroke-width=\"1.12\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol